import React, { useEffect, useState } from "react";
import { Card, Col, Row, Container } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import ApiSiteRoles from "../../../core/api/api.siteRoles";
import { IconPolicy } from "../../../assets/icons";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
function SiteRoles() {
  const [pageContent, setPageContent] = useState("");
  const [loadingData, setLoadingData] = useState(false);

  useEffect(() => {
    getData();
  }, []);
  async function getData() {
    setLoadingData(true);
    try {
      const data = await ApiSiteRoles.getInfos();

      setPageContent(data);
    } catch (error) {
      setLoadingData(false);
    } finally {
      setLoadingData(false);
    }
  }
  return (
    <>
      <Container fluid className={!isMobile ? " min-height-page" : " "}>
        <Container className="py-4 fs-normal line-height-2 text-align-justify description-text px-0 px-lg-3">
          <div className="px-3 py-4 bg-white rounded-4 mt-xl-3 mt-1 shadow-sm">
            <div className="d-flex align-items-center mb-3 border-bottom pb-3">
              <IconPolicy fillColor="#000" />
              <h1 className="fw-bold mb-0 ms-1">
                شرایط و ضوابط استفاده از سایت
              </h1>
            </div>
            {loadingData ? (
              <SkeletonTheme>
                <Skeleton height="15px" count={20}></Skeleton>
              </SkeletonTheme>
            ) : (
              <div
                className="text-align-justify description-text"
                dangerouslySetInnerHTML={{
                  __html: pageContent?.content,
                }}
              />
            )}
          </div>
        </Container>
      </Container>
    </>
  );
}
export default SiteRoles;
